<ng-container>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="table-area" *ngIf="!isLoading">
    <div class="content-body table-container">
      <table class="table-header" sortable-table="sortable-table" (sorted)="sortTableByColumn($event)">
        <colgroup>
          <col *ngFor="let col of siteTableHeader" [width]="col.width"/>
        </colgroup>
        <thead>
          <tr>
            <th *ngFor="let header of siteTableHeader" [sortable-column]="header.value" [ngClass]="header?.tooltip ? 'flex v-center' : ''">{{header.name}}
              <div class="--g-tooltip-content" *ngIf="header?.tooltip" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')">
                <comp-icon class="--g-tooltip-icon" [icon]="'info'" [size]="16" [color]="'#4f566b'"></comp-icon>
                <div class="--g-tooltip" style="text-transform: none" *ngIf="header.tooltip === 'skipped'">This feature applies only when the motion score feature is enabled. <br/>Additionally, this value is not included in AI request counts. Skipped events will be delivered to the Central station just like traditional video events.</div>
                <div class="--g-tooltip" style="text-transform: none" *ngIf="header.tooltip === 'billable'">Number of AI events counted toward billing. This matches the Video AI Charges quantity on the invoice, while AI EVENTS is the total number of AI events regardless of billing.</div>
              </div>
            </th>
          </tr>
        </thead>
      </table>
      <div class="table-body">
        <table>
          <colgroup>
            <col *ngFor="let col of siteTableHeader" [width]="col.width"/>
          </colgroup>
          <tbody>
            <tr *ngIf="pagedItems?.length === 0 && !isLoading" style="text-align: center; color: #999;">
              <td [attr.colspan]="siteTableHeader.length">{{ this.searchText?.length != 0 && this.searchText?.length < 3 ? 'Please enter at least 3 characters' : 'No Site'}}</td>
            </tr>
            <ng-container *ngIf="!isLoading">
              <tr *ngFor="let site of pagedItems" (click)="moveToDetail(site)">
                <td [class.unknown]="site.name === 'No Name'">{{site.name}}</td>
                <td *ngIf="amIMainDealer">{{site.dealer_name}}</td>
                <td *ngIf="isDivisionEnable">
                  <div [ngClass]="site.division_id ? 'division-name' : ''">{{ site.division_id ? findDivisionName(site.division_id) : '' }}</div>
                </td>
                <td>{{formatNumbersWithComma(site.device_count)}}</td>
                <td>
                  <div [ngClass]="site.videoai_enabled ? 'cloudai-enabled' : 'cloudai-disabled'">{{site.videoai_enabled ? 'Enabled' : 'Disabled'}}</div>
                </td>
                <td>{{site.video_events ?? 0}}</td>
                <td>{{site.ai_true_alarm ?? 0}}</td>
                <td>{{site.ai_false_alarm ?? 0}}</td>
                <td>{{site.ai_request ?? 0}}</td>
                <td *ngIf="isBillableMonth">{{site.ai_billable ?? 0}}</td>
                <td>
                  <div class="more-content v-center" #siteActionMenus *ngIf="tab === 'sites'" [id]="site.site_id" (mouseover)="setMorePosition(site.site_id)">
                    <div class="more-selector" (click)="$event.stopPropagation();toggleMenu(site)">
                      <comp-icon [icon]="'more_horiz'" [size]="20" [color]="'hsla(0, 0%, 0%, 0.87)'"></comp-icon>
                    </div>
                    <div class="more" [class.show]="site.isShowMenu" [id]="'more-'+site.site_id">
                      <div class="more-item pointer row" (click)="$event.stopPropagation();goToSite(site.site_id)">
                        <div>Go to Site</div>
                      </div>
                      <div class="more-item pointer row" (click)="$event.stopPropagation();moveToDetail(site)">
                        <div>Go to Detail</div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <!-- SLOT : pagination-->
      <ng-content></ng-content>
    </div>
  </div>
</ng-container>